import Cookies from 'js-cookie';

const state = {
  tableHeight: Cookies.get('tableHeight') || '300px',
};

const mutations = {
  SET_TABLE_HEIGHT: (state, tableHeight) => {
    state.tableHeight = tableHeight;
    Cookies.set('tableHeight', tableHeight);
  },
};

const actions = {
  setTableHeight({ commit }, tableHeight) {
    commit('SET_TABLE_HEIGHT', tableHeight);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
